$(".tab-clas p")
    .contents()
    .filter(function () {
    // get only the text nodes
    return this.nodeType === 3 && this.nodeValue.trim() !== "";
}).wrap("<span />");

$(".tab-clas span").attr( "tabindex","0" );
$(".tab-clas em").attr( "tabindex","0" );



//$(document).ready(function(){
  // $('.swatch input[type=radio]').prop('checked', false);
  //$(".product-gallery__thumbnail").click(function(){
   // var data_title = $(this).attr('data-title');
    //$("input[name='option-0']").each(function(){
     //var data_value = $(this).attr('value');
     // if(data_title == data_value){
      //  $(this).trigger('click'); 
      //}
    //});
  //});
  
//});
 
//$( ".pf-c h3" ).attr( "tabindex","0" );
 //$( ".pf-c li" ).attr( "tabindex","0" );
 //$( ".pf-c li a" ).attr( "tabindex","-1" );

 //$( ".pf-c h3 a" ).attr( "tabindex","-1" );
// $( ".pf-c img" ).attr( "tabindex","0" );
// $( ".pf-c p" ).attr( "tabindex","0" );
// $( ".pf-c span" ).attr( "tabindex","-1" );
// $( ".pf-c span span" ).attr( "tabindex","-1" );



$(".product-gallery__main").attr( "tabindex","-1" );

  var text = $('.collection_meta_text_bottom'),
  btn = $('.btn-overflow'),
    h = text[0].scrollHeight; 

if(h > 300) {
btn.addClass('less');
btn.css('display', 'block');
}

btn.click(function(e) 
{
e.stopPropagation();

if (btn.hasClass('less')) {
   btn.removeClass('less');
   btn.addClass('more');
   btn.text('Read less');

   text.animate({'height': h});
} else {
   btn.addClass('less');
   btn.removeClass('more');
   btn.text('Read more');
   text.animate({'height': '300px'});
}  
});
